module.exports = __webpack_public_path__ + "assets/8f09fbe7de3a885d67dd7a28eeffa523.png";